import { Component } from '@theme/component';
import { CartItemsComponent } from './component-cart-items.js';

class DorraraPackaging extends Component {
  static pending = Promise.resolve();
  static revision = 0;
  controller;
  imageIndex = 0;
  images = [];
  closingTimer;
  connectedCallback() {
    super.connectedCallback();
    this.controller?.abort();
    this.controller = new AbortController();
    const options = { signal: this.controller.signal };
    this.addEventListener('change', () => { this.syncChoice(); this.savePreferences(); }, options);
    this.addEventListener('click', (event) => this.handleClick(event), options);
    this.querySelector('dialog')?.addEventListener('cancel', (event) => { event.preventDefault(); this.closeGallery(); }, options);
    this.querySelector('dialog')?.addEventListener('keydown', (event) => {
      if (event.key === 'ArrowRight') { event.preventDefault(); this.showImage(this.imageIndex + 1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); this.showImage(this.imageIndex - 1); }
    }, options);
    document.addEventListener('shopify:block:select', (event) => {
      const image = event.target.closest?.('.dorrara-package-image');
      if (image && this.contains(image)) { this.dataset.package = image.dataset.package; image.scrollIntoView({block:'nearest',inline:'nearest'}); }
    }, options);
    document.addEventListener('shopify:block:deselect', () => this.syncChoice(), options);
    this.repeatImages();
    this.syncChoice();
  }
  updatedCallback() { super.updatedCallback(); this.syncChoice(); }
  disconnectedCallback() { super.disconnectedCallback(); this.controller?.abort(); clearTimeout(this.closingTimer); }
  repeatImages() {
    if (window.Shopify?.designMode) return;
    const gallery = this.querySelector('.dorrara-packaging__gallery');
    if (!gallery || gallery.querySelector('[data-gallery-repeat]')) return;
    for (const type of ['signature','eco']) {
      const originals = [...gallery.querySelectorAll('.dorrara-package-image')].filter(el => el.dataset.package === type);
      if (!originals.length) continue;
      for (let i = originals.length; i < 9; i++) {
        const copy = originals[i % originals.length].cloneNode(true);
        copy.dataset.galleryRepeat = ''; copy.removeAttribute('id'); copy.removeAttribute('data-shopify-editor-block');
        copy.setAttribute('aria-hidden','true'); copy.setAttribute('tabindex','-1');
        gallery.append(copy);
      }
    }
  }
  syncChoice() {
    const selected = this.querySelector('input[type="radio"]:checked');
    if (selected) this.dataset.package = selected.value;
  }
  savePreferences() {
    const attributes = {};
    const revision = ++DorraraPackaging.revision;
    this.toggleAttribute('data-pending',true);
    this.querySelectorAll('[data-attribute]').forEach((input) => {
      if (input.type === 'radio' && !input.checked) return;
      attributes[input.dataset.attribute] = input.type === 'checkbox' ? (input.checked ? 'yes' : 'no') : input.value;
    });
    const status = this.querySelector('[role="status"]');
    if (status) status.textContent = this.dataset.saving;
    const url = this.dataset.updateUrl;
    DorraraPackaging.pending = DorraraPackaging.pending.catch(() => {}).then(async () => {
      await Promise.allSettled(CartItemsComponent.pendingQuantityUpdates);
      const response = await fetch(url, {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({attributes})});
      if (!response.ok) throw new Error('Could not save packaging');
      const cart = await response.json();
      if (cart.errors) throw new Error('Could not save packaging');
      if(revision === DorraraPackaging.revision) {
        const current = document.getElementById(this.id);
        current?.querySelectorAll('[data-attribute]').forEach((input) => {
          const value = attributes[input.dataset.attribute];
          input.checked = input.type === 'checkbox' ? value === 'yes' : input.value === value;
        });
        current?.syncChoice(); current?.removeAttribute('data-pending');
        const currentStatus = current?.querySelector('[role="status"]');
        if(currentStatus) currentStatus.textContent = this.dataset.saved;
      }
    }).catch(() => { if(revision === DorraraPackaging.revision) { const current = document.getElementById(this.id);current?.removeAttribute('data-pending');const currentStatus=current?.querySelector('[role="status"]');if(currentStatus)currentStatus.textContent=this.dataset.error; } });
  }
  handleClick(event) {
    const image = event.target.closest('.dorrara-package-image');
    if (image) return;
    const dialog = this.querySelector('dialog');
    if (!dialog?.open) return;
    if(event.target.closest('[data-close]')) this.closeGallery();
    else if(event.target.closest('[data-next]')) this.showImage(this.imageIndex + 1);
    else if(event.target.closest('[data-previous]')) this.showImage(this.imageIndex - 1);
    else if(event.target.closest('[data-image-index]')) this.showImage(Number(event.target.closest('[data-image-index]').dataset.imageIndex));
    else if(event.target === dialog) {
      const rect = dialog.getBoundingClientRect();
      if(event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) this.closeGallery();
    }
  }
  openGallery(image) {
    const dialog = this.querySelector('dialog');
    this.images = [...this.querySelectorAll('.dorrara-package-image')].filter((item) => item.dataset.package === image.dataset.package);
    const thumbs = this.querySelector('.dorrara-packaging__lightbox-thumbs');
    thumbs.replaceChildren();
    this.images.forEach((item,index) => {
      const button = document.createElement('button');
      button.type = 'button'; button.dataset.imageIndex = index; button.setAttribute('aria-label',item.getAttribute('aria-label'));
      const thumbnail = document.createElement('img'); thumbnail.src = item.querySelector('img').src; thumbnail.alt = '';
      button.append(thumbnail); thumbs.append(button);
    });
    this.showImage(this.images.indexOf(image));
    dialog.classList.remove('is-closing');
    dialog.showModal();
  }
  showImage(index) {
    if (!this.images.length) return;
    this.imageIndex = (index + this.images.length) % this.images.length;
    const selected = this.images[this.imageIndex];
    const image = this.querySelector('[data-lightbox-image]');
    image.src = selected.dataset.fullImage;
    image.alt = selected.dataset.caption || selected.querySelector('img').alt;
    this.querySelector('[data-lightbox-caption]').textContent = selected.dataset.caption || '';
    this.querySelectorAll('[data-image-index]').forEach((button) => {
      const current = Number(button.dataset.imageIndex) === this.imageIndex;
      button.setAttribute('aria-current',String(current));
      if(current) button.scrollIntoView({block:'nearest',inline:'nearest'});
    });
  }
  closeGallery() {
    const dialog = this.querySelector('dialog');
    if(!dialog?.open) return;
    clearTimeout(this.closingTimer);
    if(window.matchMedia('(prefers-reduced-motion: reduce)').matches) { dialog.close(); return; }
    dialog.classList.add('is-closing');
    this.closingTimer = setTimeout(() => { dialog.close(); dialog.classList.remove('is-closing'); },250);
  }
}
if(!customElements.get('dorrara-packaging')) customElements.define('dorrara-packaging',DorraraPackaging);
